import { message } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

import { useSosEditContainerEditSosItemMutation, useSosEditContainerQuery } from '@/graphql';
import { viewFactory } from '@/utils';

import { SosEditView } from './SosEditView';

const SosEditContainer = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const query = useSosEditContainerQuery({ variables: { id: String(id) } });
    const [editSos] = useSosEditContainerEditSosItemMutation({
        onError: (error) => message.error(error.message),
    });

    const handleBackToList = () => navigate('/sos/my-sos');
    const handleSubmit = async (values: { message: string }) => {
        await editSos({
            variables: {
                input: {
                    id: String(id),
                    message: values.message,
                },
            },
        });

        handleBackToList();
    };

    const { data, loading, refetch, error = null } = query;
    return viewFactory(
        SosEditView,
        { data, loading, refetch, error },
        {
            onBack: handleBackToList,
            onSubmit: handleSubmit,
        }
    );
};

export { SosEditContainer };
